module.exports = __webpack_public_path__ + "static/media/login-bg.b2d5b2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login-bg.jpg
// module id = 9591
// module chunks = 23